import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { RouterModule } from '@angular/router'

import { FlxIconModule } from '@flowx/angular-ui-toolkit'
import {
  NavMenuItemChild,
  NavMenuRoute,
} from '@flowx/designer/modules/layout/components/nav-menu/nav-menu.dictionary'

@Component({
  selector: 'flx-nav-menu-item',
  templateUrl: './nav-menu-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, RouterModule, FlxIconModule],
})
export class FlxNavMenuItemComponent {
  icon = input<string>(null)
  useCustomIcon = input<boolean>(false)
  name = input<string>(null)
  route = input<NavMenuRoute>(null)
  children = input<NavMenuItemChild[]>(null)
}
